import "./HairSurgery.module.css";
import NavegaciNPrincipal from "@/reusable_sections/Header";
import ResultadosRealesConPrecisiN from "./sections/ResultadosRealesConPrecisiN";
import ElProcesoDeTransformaciN from "./sections/ElProcesoDeTransformaciN";
import PreguntasFrecuentesSobreCirugA from "./sections/PreguntasFrecuentesSobreCirugA";
import PieDePGinaInstitucional from "@/reusable_sections/Footer";
export default function HairSurgeryPage() {
  return <div>
      <NavegaciNPrincipal />
      <ResultadosRealesConPrecisiN />
      <ElProcesoDeTransformaciN />
      <PreguntasFrecuentesSobreCirugA />
      <PieDePGinaInstitucional />
    </div>;
}